import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Title = styled.span`
  display: block;
  margin-left: 12px;
  margin-bottom: 8px;
  color: ${uiToken.color.text.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const Container = styled.dl`
  display: block;
  margin: 0;
  padding: 0;
  background-color: ${uiToken.color.background.secondary};
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 10%);
`;

export const Row = styled.div`
  display: flex;
  padding: 16px;
  position: relative;
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;

  &:not(:last-child)::after {
    display: block;
    height: 1px;
    position: absolute;
    right: 1px;
    bottom: 0;
    left: 1px;
    background-color: rgb(255 255 255 / 10%);
    content: '';
  }
`;

export const Value = styled.dd`
  margin: 0;
  padding: 0;
  color: ${uiToken.color.text.primary};
`;
